import { Key, ReactElement, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WHITELIST_END_TIME } from "@/constants/whitelist";
import style from "./MintCountdown.module.scss";

const TARGET_UTC_MS = new Date(WHITELIST_END_TIME).getTime();

function MintCountdown() {
  const [remainingMs, setRemainingMs] = useState(() =>
    Math.max(0, TARGET_UTC_MS - Date.now())
  );

  useEffect(() => {
    const tick = () => setRemainingMs(Math.max(0, TARGET_UTC_MS - Date.now()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const totalSeconds = Math.floor(remainingMs / 1000);
  const days = Math.floor(totalSeconds / (24 * 3600));
  const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const started = remainingMs <= 0;

  interface RenderNumber {
    (value: string | number): ReactElement;
  }

  const renderNumber: RenderNumber = (value) => (
    <div className={style.timePart}>
      <AnimatePresence mode="popLayout">
        <motion.span
          key={value as Key}
          className={style.number}
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 20, opacity: 0 }}
          transition={{ duration: 0.25 }}
        >
          {value}
        </motion.span>
      </AnimatePresence>
    </div>
  );

  return (
    <div className={style.wrapper}>
      <div className={style.background}>
        <img src="/images/mint-bg.png" alt="" />
      </div>
      <div className={style.container}>
        <h2 className={style.title}>Mint Starts In</h2>

        {!started ? (
          <div className={style.countdown}>
            {renderNumber(days)}
            <span className={style.unit}>days</span>
            {renderNumber(String(hours).padStart(2, "0"))}
            <span className={style.unit}>hrs</span>
            {renderNumber(String(minutes).padStart(2, "0"))}
            <span className={style.unit}>mins</span>
            {renderNumber(String(seconds).padStart(2, "0"))}
            <span className={style.unit}>secs</span>
          </div>
        ) : (
          <motion.div
            className={style.started}
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4 }}
          >
            MINT STARTED
          </motion.div>
        )}
      </div>
    </div>
  );
}

export default MintCountdown;
